import { Service } from 'typedi';
import { CommunicatorPageStore } from './Communicator/CommunicatorPageStore';
import ioc from '../../services/ioc';
import { InvalidConfigurationException } from '@enterprise/common';

const ONBOARDING_STORES_MAP = {
    PHNPro: CommunicatorPageStore,
};

export interface OnboardingPageStoreInterface {
    load(): Promise<any>;

    dispose(): Promise<any>;
}

@Service()
export class OnboardingPageStore {
    private stores: { [name: string]: OnboardingPageStoreInterface } = {};

    getSubStore = async (name: string): Promise<OnboardingPageStoreInterface | any> => {
        if (this.stores[name]) {
            return this.stores[name];
        }
        if (!ONBOARDING_STORES_MAP[name]) {
            return Promise.reject(new InvalidConfigurationException(`Onboarding Store with name "${name}" is not registered`));
        }
        const storeInstance = ioc.get<OnboardingPageStoreInterface>(ONBOARDING_STORES_MAP[name]);
        this.stores[name] = storeInstance;
        await storeInstance.load();
        return this.stores[name];
    };

    disposeStore = async (name: string) => {
        if (this.stores[name]) {
            const res = await this.stores[name].dispose();
            delete this.stores[name];

            return res;
        }

        return Promise.reject(new InvalidConfigurationException(`Onboarding Store with name "${name}" is not registered`));
    };
}
